import { Tag } from "./tag.js";
import { styles } from "./tag.styles.js";
import { template } from "./tag.template.js";
import { DesignSystem } from "../design-system.js";
/**
 *
 * @public
 * @remarks
 * HTML Element: <fabric-tag>
 */
export const definition = Tag.compose({
    name: `${DesignSystem.prefix}-tag`,
    template,
    styles,
    shadowOptions: {
        mode: DesignSystem.shadowRootMode
    }
});
//# sourceMappingURL=tag.definition.js.map